import get from 'lodash/get';
import { formConstants } from '../../utils/constants/form-constants';
import { formFieldValidators } from './form-field-validators';
import {
    validateSelectedCounty,
    validateSelectedState
} from '../../../validators/text-validators';
import { isEmpty } from '../../utils/obj-utils';

const FormValidator = (
    formData,
    formValues
) => {
    function validateForm() {
        const errors = {};
        const formDataKeys = Object.keys(formData);

        formDataKeys.forEach((formDataKey) => {
            if (isEmpty(formData[formDataKey])) return;
            if (!formData[formDataKey].isHidden && !formData[formDataKey].isOptional) {
                errors[formDataKey] = validateField(formDataKey);
            }

            if (formData[formDataKey].isOptional && !isEmpty(formValues[formDataKey])) {
                errors[formDataKey] = validateField(formDataKey);
            }
        });

        return { errors, formHasErrors: hasErrors(errors) };
    }

    function hasErrors(errors) {
        const errorKeys = Object.keys(errors);
        return errorKeys.some((key) => {
            if (errors[key] === null || errors[key] === undefined) {
                return false;
            }

            return !errors[key].isValid;
        });
    }

    function validateField(formDataKey) {
        const validator = formFieldValidators[formDataKey];
        const fieldValue = formValues[formDataKey];

        if (validator === undefined) {
            return null;
        }

        if (formDataKey === formConstants.confirmPassword) {
            const passwordFieldValue = formValues[formConstants.password];
            return validator(passwordFieldValue, fieldValue);
        }

        if (formDataKey === formConstants.oldPassword) {
            const passwordFieldValue = formValues[formConstants.password];
            return validator(passwordFieldValue, fieldValue);
        }

        if (formDataKey === formConstants.county) {
            const selectedCountryCode = formValues[formConstants.country];
            const selectedCounty = formValues[formConstants.county];
            const { county } = formData;
            return validateSelectedCounty(selectedCounty, selectedCountryCode, county);
        }

        if (formDataKey === formConstants.state) {
            const selectedCountryCode = formValues[formConstants.country];
            const selectedState = formValues[formConstants.state];
            const stateField = get(formData, 'state', null);
            return validateSelectedState(selectedState, selectedCountryCode, stateField);
        }

        if (formDataKey === formConstants.mobilePhone) {
            const { mobilePhone } = formData;
            if (fieldValue) {
                return validator(fieldValue.phoneNumber, mobilePhone.isOptional);
            }
            return validator(fieldValue, mobilePhone.isOptional);
        }

        if (formDataKey === formConstants.mastercard) {
            const mastercardFieldValue = formValues[formConstants.mastercard];
            return validator(mastercardFieldValue, formData.mastercardRegex, formData.mastercardValidationError);
        }

        return validator(fieldValue);
    }

    return validateForm();
};

export default FormValidator;
